// Shared helpers for computing the next prayer + picking a surah that fits the
// remaining time before it. Used by the home feature slider and the Quran reader.

export const PRAYER_ORDER = ['Fajr', 'Dhuhr', 'Asr', 'Maghrib', 'Isha'];

// Surahs short enough to finish in a couple of minutes (3–9 verses each)
export const VERY_SHORT_SURAHS = [103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114];

/** Returns the next upcoming prayer as { name, date, raw } (raw = "HH:MM"). */
export function getNextPrayer(prayerTimes) {
  if (!prayerTimes) return null;
  const now = new Date();
  for (const name of PRAYER_ORDER) {
    const raw = (prayerTimes[name] || '').split(' ')[0];
    if (!raw) continue;
    const [h, m] = raw.split(':').map(Number);
    const d = new Date();
    d.setHours(h, m, 0, 0);
    if (d > now) return { name, date: d, raw };
  }
  // All of today's prayers passed → tomorrow's Fajr
  const raw = (prayerTimes.Fajr || '').split(' ')[0];
  if (!raw) return null;
  const [h, m] = raw.split(':').map(Number);
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(h, m, 0, 0);
  return { name: 'Fajr', date: d, raw };
}

/** Minutes from now until the given Date (never negative). */
export function minutesUntil(date) {
  return Math.max(0, Math.round((date - new Date()) / 60000));
}

/**
 * Picks a surah id (1–114) appropriate for the time left before the next prayer:
 *  - ≤ 8 min  → a very short surah
 *  - ≤ 20 min → a short surah from Juz' Amma (78–114)
 *  - else     → any surah
 */
export function pickSurahForTime(prayerTimes) {
  const next = getNextPrayer(prayerTimes);
  const mins = next ? minutesUntil(next.date) : 999;
  let pool;
  if (mins <= 8) pool = VERY_SHORT_SURAHS;
  else if (mins <= 20) pool = Array.from({ length: 114 - 78 + 1 }, (_, i) => 78 + i);
  else pool = Array.from({ length: 114 }, (_, i) => i + 1);
  return pool[Math.floor(Math.random() * pool.length)];
}
